import { translate } from "@/main"
import VueStore from "@/store/VueStore";

export default class LanguageSettingConfig {
  public static languageChoices() {
    return [
      { text: translate("message.english") as string, value: "en" },
      { text: translate("message.japanese") as string, value: "ja" }
    ]
  }
  /**
   * @param 変更先言語(languageChoices関数がもつ"value"の値)
   * main.tsでi18nが再生成される際にlocalStorageが参照されることを利用した言語切替機能
   * そのため、この関数の呼び出し後にページをリロードする必要がある
   */
  public static saveLanguageSettingToStorages(selectedLanguage: string) {
    localStorage.setItem("language", selectedLanguage);
    VueStore.commit("setLanguage", selectedLanguage);
  }
}
